<!--
  One plan suggestion as a single line on the roadmap. Deliberately just a summary and a way in: clicking it opens
  the full SuggestionCard, which owns every action, so the roadmap never grows a second (drifting) copy of them.
  Dashed so it reads as "planned", next to the solid rows of campaigns that are actually booked.
-->
<template>
  <div
    class="d-flex align-center mt-1 suggestion-row"
    :title="item.rationale || ''"
    @click="$emit('open')"
  >
    <v-icon
      small
      class="mr-2"
      color="grey"
    >
      {{ typeMeta.icon }}
    </v-icon>

    <a
      class="text-body-2 mr-2"
      href="#"
      @click.prevent
    >{{ item.title }}</a>

    <v-chip
      x-small
      :color="statusMeta.color"
      dark
      class="mr-2"
    >
      {{ statusMeta.label }}
    </v-chip>

    <span
      v-if="platformLabel"
      class="text-caption grey--text mr-2"
    >{{ platformLabel }}</span>

    <span
      v-if="note"
      class="text-caption grey--text mr-2"
    >{{ note }}</span>

    <v-icon
      v-if="warning"
      small
      color="warning"
      :title="warning"
    >
      mdi-alert-outline
    </v-icon>
  </div>
</template>

<script>
import { platformName, planItemStatus } from '@/helpers/marketing';

export default {
  name: 'AudienceSuggestionRow',
  props: {
    item: {
      type: Object,
      required: true
    },
    // Extra context the roadmap wants on the line, e.g. that the item's planned week has already passed.
    note: {
      type: String,
      default: ''
    }
  },
  computed: {
    detail() {
      return this.item.detail || {};
    },
    typeMeta() {
      return this.$enums.AUDIENCE.ITEM_TYPE[this.item.itemType] || { icon: 'mdi-dots-horizontal' };
    },
    statusMeta() {
      return planItemStatus(this.item);
    },
    platformLabel() {
      return (this.detail.platforms || []).map(platformName).filter(Boolean).join(', ');
    },
    // The same two draft-time flags the card shows in full; here just a marker that there is something to read.
    warning() {
      return this.detail.repeatNote || this.detail.copyWarning || '';
    }
  }
};
</script>

<style scoped>
.suggestion-row {
  cursor: pointer;
  border: 1px dashed rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 2px 6px;
}

.suggestion-row:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>
